import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { getQualityReport, setBenchmark } from '../lib/api'

export const qualityKeys = {
	all: ['quality'] as const,
}

export const qualityReportQuery = () => queryOptions({ queryKey: qualityKeys.all, queryFn: getQualityReport })

export function useSetBenchmark() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: setBenchmark,
		onSettled: () => queryClient.invalidateQueries({ queryKey: qualityKeys.all }),
	})
}
